export default __webpack_public_path__ + "static/media/cancer-diagnosis.aa3b8ec5.svg";